import { render, staticRenderFns } from "./UserSetupPage.vue?vue&type=template&id=2f7b568a&scoped=true&"
import script from "./UserSetupPage.vue?vue&type=script&lang=js&"
export * from "./UserSetupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b568a",
  null
  
)

export default component.exports